document.addEventListener("DOMContentLoaded", function () {
  let swiperInstance;

  function initOrDestroySwiper() {
    const screenWidth = window.innerWidth;

    if (screenWidth <= 768 && !swiperInstance) {
      // Initialize Swiper on mobile
      swiperInstance = new Swiper(".our-mission-wrapper", {
        slidesPerView: 1,
        spaceBetween: 20,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      });
    } else if (screenWidth > 768 && swiperInstance) {
      // Destroy Swiper on desktop
      swiperInstance.destroy(true, true);
      swiperInstance = null;
    }
  }

  // Run on load and resize
  initOrDestroySwiper();
  window.addEventListener("resize", initOrDestroySwiper);
});
